export default __webpack_public_path__ + "static/media/covid-cells.d8ec0f1b.jpg";